<template>
	<div class="page">
		<!-- your page -->
		<div class="infoBox">
			<div class="title">
				<div class="titlebox">
					个人信息
				</div>
				<div class="edit" @click="editBtn">
					<i class="el-icon-edit"></i>编辑
				</div>
			</div>
			<div class="avatar">
				<div class="leftTitle">
					头像：
				</div>
				<div class="rightBox">
					<div class="avatarIn">
						<input type="file" v-show="edit" accept="image/*" @change="imgUpload"/>
						<img :src="userinfo.avatar" alt="">
					</div>
					<div class="hint" v-show="edit">点击图片更换头像</div>
				</div>
			</div>
			<div class="username">
				<div class="leftTitle">
					昵称：
				</div>
				<div class="rightBox">
					<span v-show="!edit">{{userinfo.nickname}}</span>
					<input type="text" v-model="userinfo.nickname" v-show="edit" class="userInput">
				</div>
			</div>
			<div class="phone">
				<div class="leftTitle">
					绑定手机号：
				</div>
				<div class="rightBox">
					<span>{{userinfo.mobile}}</span>
					<button v-show="edit">更换绑定</button>
				</div>
			</div>
			<div class="sex">
				<div class="leftTitle">
					性别：
				</div>
				<div class="rightBox">
					<span v-show="!edit"><span v-show="userinfo.sex==1">男</span><span v-show="userinfo.sex==2">女</span><span v-show="userinfo.sex==3">保密</span></span>
					<div class="choose" v-show="edit">
						<div class="now"></div>
						<div class="box">
							<div class="item">
								<div class="radio">
									<div class="radioIn" @click="chooseSex" :data-id="1">
										<div class="point" v-show="userinfo.sex==1" :data-id="1"></div>
									</div>
								</div>
								<div class="word">男</div>
							</div>
							<div class="item">
								<div class="radio">
									<div class="radioIn" @click="chooseSex" :data-id="2">
										<div class="point" v-show="userinfo.sex==2" :data-id="2"></div>
									</div>
								</div>
								<div class="word">女</div>
							</div>
							<div class="item">
								<div class="radio">
									<div class="radioIn" @click="chooseSex" :data-id="3">
										<div class="point" v-show="userinfo.sex==3" :data-id="3"></div>
									</div>
								</div>
								<div class="word">保密</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="enter" v-show="edit">
				<button class="enterBtn" @click="submitEdit">确认</button>
				<button class="cancel" @click="cancelEdit">取消</button>
			</div>
		</div>
	</div>
</template>

<script>
	// your script
	export default {
		name: 'info',
		data(){
			return {
				userinfo:{},
				edit:false
			}
		},
		inject:['getParentInfo'],
		methods:{
			imgUpload(e){
				var $target = e.target || e.srcElement
				var file = $target.files[0]
				var formData = new FormData()
				formData.append('token',this.token)
				formData.append('image',file,file.name)
				formData.append('method','images.upload')
				formData.append('type','image')
				var that = this
				this.uploadFile(formData,function(res){
					console.log(res)
					if(res.status){
						var avatar = res.data.url
						that.changeAvatar(avatar)
					}else{
						that.globalTest('images.upload','error',res.msg,res.data)
					}
				})
			},
			changeAvatar(avatar){
				var data = {
					avatar:avatar,
					token:this.token,
					method:"user.changeavatar"
				}
				var that = this
				this.request(data,function(res){
					console.log(res)
					if(res.status){
						that.globalTest('user.changeavatar','success','头像修改成功')
						var userinfo = {
							"username":that.userinfo.username,
							"avatar":res.data.avatar,
							"id":that.userinfo.id,
							"mobile":that.userinfo.mobile,
							"nickname":that.userinfo.nickname,
							"score":that.userinfo.score,
							"sex":that.userinfo.sex
						}
						that.userinfo = userinfo
						localStorage.setItem('userInfo',JSON.stringify(userinfo))
						that.recv()
					}else{
						that.globalTest('user.editinfo','error',res.msg,res.data)
					}
				})
			},
			chooseSex(e){
				var id = e.target.dataset.id
				this.userinfo.sex = id
			},
			submitEdit(){
				var data = {
					sex:this.userinfo.sex,
					nickname:this.userinfo.nickname,
					token:this.token,
					method:"user.editinfo"
				}
				var that = this
				this.request(data,function(res){
					if(res.status){
						that.globalTest('user.editinfo','success','个人信息修改成功')
						var userinfo = {
							"username":that.userinfo.username,
							"avatar":that.userinfo.avatar,
							"id":that.userinfo.id,
							"mobile":that.userinfo.mobile,
							"nickname":that.userinfo.nickname,
							"score":that.userinfo.score,
							"sex":that.userinfo.sex
						}
						that.userinfo = userinfo
						localStorage.setItem('userInfo',JSON.stringify(userinfo))
						that.edit = false
						that.recv()
					}else{
						that.globalTest('user.editinfo','error',res.msg,res.data)
					}
				})
			},
			recv(){
				this.getParentInfo()
			},
			cancelEdit(){
				this.edit=false
			},
			getUserInfo(){
				var userinfo = localStorage.getItem('userInfo')
				this.userinfo = JSON.parse(userinfo)
			},
			editBtn(){
				if(!this.edit){
					this.edit=true
				}else{
					this.edit=false
				}
			}
		},
		beforeCreate: function() {
			//生命周期 -- 组件实例刚被创建，组件属性计算之前，如DATA属性等
		},
		created: function() {
			//生命周期 -- 组件实例创建完成，属性已绑定，但DOM还未生成，$el属性还不存在
		},
		beforeMount: function() {
			//模板编译/挂载之前
		},
		mounted: function() {
			//模板编译/挂载之后
			this.token = localStorage.getItem('token')
			if(this.token!=null){
				this.getUserInfo()
			}
		},
		beforeUpdate: function() {
			//组件更新之前
		},
		updated: function() {
			//组件更新之后
		},
		activated: function() {
			// for keep-alive，组件被激活时调用
		},
		deactivated: function() {
			// for keep-alive，组件被移除时调用
		},
		beforeDestory: function() {
			// 组件销毁调用
		},
		destoryed: function() {
			// 组件销毁后调用
		}
	}
</script>

<style scoped>
	/* your css */
	.infoBox{
		width: 100%;
		padding: 0px 10px;
		box-sizing: border-box;
	}
	.title{
		width: 100%;
		height: 50px;
		border-bottom: 1px solid #C3C3C3;
		line-height: 60px;
	}
	.titlebox,.edit{
		height: 100%;
		float: left;
	}
	.titlebox{
		width: 840px;
	}
	.edit{
		width: 80px;
		text-align: right;
		cursor: pointer;
	}
	.edit:hover{
		color: #036DEE;
	}
	.avatar,.username,.phone,.sex{
		width: 100%;
		height: 60px;
		line-height: 60px;
		position: relative;
	}
	.avatar{
		margin-top: 20px;
	}
	.avatar{
		height: 80px;
		line-height: 80px;
	}
	.avatarIn{
		width: 80px;
		height: 100%;
		border: 2px solid #C3C3C3;
		border-radius: 50%;
		box-sizing: border-box;
		overflow: hidden;
		float: left;
		position: relative;
	}
	.hint{
		width: 150px;
		height: 100%;
		float: left;
		padding-left: 10px;
		box-sizing: border-box;
		font-size: 12px;
		color: #036DEE;
	}
	.avatarIn img{
		width: 100%;
		height: 100%;
		display: block;
	}
	.avatarIn input{
		width: 100%;
		height: 100%;
		position: absolute;
		left: 0px;
		top: 0px;
		z-index: 10;
		opacity: 0;
	}
	.leftTitle{
		width: 100px;
		height: 100%;
		position: absolute;
		left: 0px;
		top: 0px;
		text-align: right;
	}
	.rightBox{
		width: 100%;
		height: 100%;
		padding-left: 110px;
		box-sizing: border-box;
	}
	.userInput{
		width: 200px;
		height: 34px;
		display: block;
		border: 1px solid #E3E3E3;
		float: left;
		margin-top: 13px;
		background: #F0F0F0;
		padding-left: 10px;
		box-sizing: border-box;
	}
	.rightBox button{
		width: 80px;
		height: 26px;
		border: none;
		background: none;
		font-size: 12px;
		color: #036DEE;
		cursor: pointer;
		margin-top: 17px;
	}
	.choose{
		width: 300px;
		height: 100%;
	}
	.box{
		width: 200px;
		height: 100%;
		float: left;
	}
	.box .item{
		width: 60px;
		height: 100%;
		float: left;
	}
	.radio{
		width: 25px;
		height: 100%;
		float: left;
	}
	.radioIn{
		width: 16px;
		height: 16px;
		border: 1px solid #C3C3C3;
		box-sizing: border-box;
		margin-top: 22px;
		border-radius: 50%;
		padding-top: 3px;
	}
	.radioIn .point{
		width: 8px;
		height: 8px;
		background: #4C95EF;
		border-radius: 50%;
		margin: 0 auto;
	}
	.enter{
		width: 100%;
		height: 40px;
		padding-left: 50px;
		box-sizing: border-box;
	}
	.enterBtn,.cancel{
		width: 100px;
		height: 100%;
		float: left;
	}
	.rightBox .enterBtn{
		background: #036DEE;
		color: #FFFFFF;
	}
	.rightBox .cancel{
		border: 1px solid #036DEE;
		box-sizing: border-box;
		margin-left: 20px;
	}
</style>
